import React from 'react';
import './Card.css';  // Import the CSS for card styling
import diagonalLines from '../assets/diagonal-lines.png';

const Card = ({ heading, body }) => {
  return (
    <div className="card-container" >
      <div className="card-heading">{heading}</div>
      <div 
        className="card-body"
      >{body}</div>
    </div>
  );
};

export default Card;

//style={{ backgroundImage: `url(${diagonalLines})` }}